import { render, staticRenderFns } from "./TabContentMatches.vue?vue&type=template&id=e326644a&scoped=true"
import script from "./TabContentMatches.vue?vue&type=script&lang=js"
export * from "./TabContentMatches.vue?vue&type=script&lang=js"
import style0 from "./TabContentMatches.vue?vue&type=style&index=0&id=e326644a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e326644a",
  null
  
)

export default component.exports